import RelayEnvironment from 'lib/utils/relay';
import { loadQuery } from 'react-relay';
import { getUserId } from 'lib/utils/authentication';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { eventsQuery } from 'services/event/__generated__/eventsQuery.graphql';
import { EVENTS_QUERY } from 'services/event/event.relay.services';
import { teamsQuery } from 'services/team/__generated__/teamsQuery.graphql';
import { TEAMS_QUERY } from 'services/team/team.relay.services';

export const DefaultPreloadData = Props => {
  const userId = getUserId() ?? '';
  return {
    eventsQueryRef: loadQuery<eventsQuery>(
      RelayEnvironment,
      EVENTS_QUERY,
      {
        first: 20,
        ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
        filter: {
          where: {
            and: { userId: { equalTo: userId } },
            deletedAt: { isNull: true },
            cancellationDatetime: { isNull: true },
            status: { equalTo: 'requested' },
          },
        },
        skip: !userId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
    teamsQueryRef: loadQuery<teamsQuery>(
      RelayEnvironment,
      TEAMS_QUERY,
      {
        userId,
        skip: !userId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
    userProfileQueryRef: loadQuery<userProfileQuery>(
      RelayEnvironment,
      USER_PROFILE_QUERY,
      {
        id: userId,
        skip: !userId,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type DefaultPreloadDataType = ReturnType<typeof DefaultPreloadData>;
